<template>
  <div id="app">
    <Twitter tweets="tweets go here"/>
    <Overlay embed="embed goes here"/>
    <Prizes prizes="prizes go here"/>
    <Filenames/>
    <Events/>
    <Wheelspins/>
    <Bottombar/>
  </div>
</template>

<script>
import Twitter from './components/Twitter.vue'
import Overlay from './components/Overlay.vue'
import Prizes from './components/Prizes.vue'
import Filenames from './components/Filenames.vue'
import Events from './components/Events.vue'
import Wheelspins from './components/Wheelspins.vue'
import Bottombar from './components/Bottombar.vue'

export default {
  name: 'app',
  components: {
    Twitter,
    Overlay,
    Prizes,
    Filenames,
    Events,
    Wheelspins,
    Bottombar
  }
}
</script>

<style>
#app {
  y-overflow:hidden;
  x-overflow:hidden;
  margin:0px;
  background-color:green;
  font-family:sans-serif;
  font-weight:600;
  font-size:3vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue